import styled from 'styled-components';

import { SingleSizeIllustrationHeroJobs } from '@xing-com/illustrations';
import { mediaConfined } from '@xing-com/layout-tokens';
import {
  scale100,
  spaceL,
  spaceXXL,
  xdlColorBackgroundTertiary,
} from '@xing-com/tokens';
import { Headline, Hero, BodyCopy } from '@xing-com/typography';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${xdlColorBackgroundTertiary};
  padding: calc(2 * ${spaceXXL}) ${scale100};

  /* necessary to be wider than what grid allows */
  max-width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
`;

export const Illustration = styled(SingleSizeIllustrationHeroJobs)`
  height: 153px;
  margin-bottom: ${spaceXXL};
  width: 203px;

  @media ${mediaConfined} {
    height: 203px;
    width: 269px;
  }
`;

export const TitleHandheld = styled(Headline)`
  margin-bottom: ${spaceXXL};
`;

export const TitleDesktop = styled(Hero)`
  @media ${mediaConfined} {
    margin-bottom: ${spaceL};
  }
`;

export const Text = styled(BodyCopy)`
  margin-bottom: ${spaceXXL};
`;
